import React from "react";

const COMING_IMG =
  "https://images.pexels.com/photos/31094157/pexels-photo-31094157.jpeg";

const PIPELINE = [
  { tag: "Phase 02", name: "Premium dried fruit" },
  { tag: "Phase 02", name: "Specialty nut butters" },
  { tag: "Phase 03", name: "Rare grains & flours" },
  { tag: "Phase 03", name: "Athlete pantry staples" },
];

export const ComingSoon = () => {
  return (
    <section
      id="coming-soon"
      data-testid="coming-soon-section"
      className="py-24 md:py-32 bg-bone"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-stretch">
          {/* Visual */}
          <div className="lg:col-span-7 relative">
            <div className="relative aspect-[4/3] md:aspect-[16/10] overflow-hidden rounded-sm">
              <img
                src={COMING_IMG}
                alt="Artisanal dried fruit in wicker bowls"
                className="w-full h-full object-cover"
                loading="lazy"
                data-testid="coming-soon-image"
              />
              <div className="absolute inset-0 bg-gradient-to-br from-black/30 via-transparent to-black/40"></div>
              <div className="absolute top-6 left-6">
                <span className="overline bg-bone text-ink px-3 py-1.5 rounded-sm">
                  Coming next
                </span>
              </div>
              <div className="absolute bottom-6 left-6 right-6 md:right-auto md:max-w-md">
                <p className="font-wordmark italic text-bone/95 text-2xl md:text-3xl leading-snug">
                  A pantry of hard-to-find goods, arriving slowly.
                </p>
              </div>
            </div>
          </div>

          {/* Text + pipeline */}
          <div className="lg:col-span-5 flex flex-col justify-between">
            <div>
              <div className="overline text-terracotta mb-4">Phase 02 & Beyond</div>
              <h2 className="font-display font-black text-4xl md:text-5xl text-ink tracking-tight leading-[1.02]">
                What we’re sourcing
                <br />
                <span className="font-wordmark italic font-semibold text-ink/85">
                  next.
                </span>
              </h2>
              <p className="mt-5 text-ink/75 text-base md:text-lg leading-relaxed">
                Things that simply aren’t on UAE shelves yet — or are stocked
                inconsistently. We add slowly, and only when we’d eat it
                ourselves.
              </p>
            </div>

            <ul className="mt-10 border-t border-hairline">
              {PIPELINE.map((item, i) => (
                <li
                  key={i}
                  data-testid={`pipeline-item-${i}`}
                  className="flex items-center justify-between py-5 border-b border-hairline group cursor-default"
                >
                  <div className="flex items-baseline gap-5">
                    <span className="overline text-terracotta">{item.tag}</span>
                    <span className="font-display font-semibold text-ink text-lg md:text-xl">
                      {item.name}
                    </span>
                  </div>
                  <span className="text-inkmute text-sm font-body opacity-0 group-hover:opacity-100 transition-opacity">
                    soon
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
